import React, { useState } from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';
import Img from 'gatsby-image';
import YouTube from 'react-youtube';

import Wrapper from '../elements/wrapper';
import { media } from '../helpers';
import { motion, AnimatePresence } from 'framer-motion';

import PlayIcon from '../../images/icons/play-circle.inline.svg';

const CollectionVideoContainer = styled.div`
    position: relative;
    z-index: 10;
    padding-bottom: 10vh;
    ${media.medium`padding-bottom: 0vh;`}
    .collection-video-wrapper {
        max-width: 100vw;
        ${media.medium`display: flex; max-width:90vw;`}

        .video-container {
            flex: 2;
            order: 2;
            position: relative;

            .play-btn-container {
                position: absolute;
                top: 0;
                height: 100%;
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                button {
                    line-height: 1;
                    border: none;
                    background-color: transparent;
                    padding: 5px;
                    display: inline-block;
                    &:active,
                    &:focus {
                        outline: 0;
                    }
                    svg {
                        height: 50px;
                        width: 50px;
                        fill: #f74d33;
                        ${media.medium`height: 100px;width: 100px;`}

                        circle {
                            box-shadow: 10px 10px 20px rgba(0, 0, 0, 0.12);
                            stroke: #f74d33;
                        }

                        polygon {
                            stroke: #fff;
                            fill: #fff;
                        }
                    }
                }
            }
        }
        .content-outer-container {
            flex: 1;
            order: 1;
            position: relative;

            .content-container {
                background-color: #f2f0eb;
                box-shadow: 10px 10px 20px rgba(0, 0, 0, 0.12);
                ${media.medium`position: absolute;left: 5vw;width: 100%;top: 35%;`}

                .inner-wrap {
                    padding: 40px;

                    h3 {
                        font-size: 2rem;
                        margin: 0 0 10px;
                        font-family: neue-kabel, sans-serif;
                        font-weight: 800;
                        color: #000;
                    }
                    p {
                        font-size: 1.1rem;
                        max-width: 100%;
                        line-height: 1.5;
                        margin: 0 0 20px;
                        ${media.medium`max-width: 80%;`}
                    }

                    button {
                        color: #f74d33;
                        font-weight: 800;
                        font-size: 1.2rem;
                        font-family: neue-kabel, sans-serif;
                        border: none;
                        background-color: transparent;
                        text-decoration: underline;

                        &:hover {
                            opacity: 0.7;
                        }
                    }
                }
            }
        }
    }
`;

const CollectionVideo = ({ settings }) => {
    const [isVideoShowing, setIsVideoShowing] = useState(false);
    const { videoImage, videoTitle, videoCaption, videoSource, videoLinkText } =
        settings || {};
    return (
        <>
            <CollectionVideoContainer>
                <Wrapper className="collection-video-wrapper">
                    <div className="video-container">
                        {videoImage && (
                            <Img
                                fluid={
                                    videoImage.localFile.childImageSharp.fluid
                                }
                            ></Img>
                        )}
                        <div className="play-btn-container">
                            <button
                                onClick={() =>
                                    setIsVideoShowing(!isVideoShowing)
                                }
                            >
                                <PlayIcon />
                            </button>
                        </div>
                    </div>
                    <div className="content-outer-container">
                        <div className="content-container">
                            <div className="inner-wrap">
                                <h3>{videoTitle}</h3>
                                <p>{videoCaption}</p>
                                {videoLinkText && (
                                    <div className="btn-container">
                                        <button
                                            onClick={() =>
                                                setIsVideoShowing(
                                                    !isVideoShowing
                                                )
                                            }
                                        >
                                            {videoLinkText}
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </Wrapper>
            </CollectionVideoContainer>
            <AnimatePresence>
                {isVideoShowing && (
                    <VideoLightbox
                        video={videoSource}
                        setIsVideoShowing={setIsVideoShowing}
                    />
                )}
            </AnimatePresence>
        </>
    );
};

const VideoLightboxContainer = styled(motion.div)`
    background-color: rgb(0, 0, 0, 0.75);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 6000;
    height: 100vh;
    width: 100%;
    display: flex;
    align-items: center;

    .close-button {
        position: absolute;
        top: 0;
        left: 0;
        height: 100vh;
        width: 100%;
        background-color: transparent;
        border: none;
    }
    .iframe-container {
        position: relative;
        width: 90vw;
        ${media.medium`width: 50vw;`}
        > div {
            position: relative;
            overflow: hidden;
            padding-top: 56.25%;

            iframe {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                border: 0;
            }
        }
    }
`;
const VideoLightbox = ({ setIsVideoShowing }) => {
    const opts = {
        height: '390',
        width: '640',
        playerVars: {
            // https://developers.google.com/youtube/player_parameters
            autoplay: 1,
        },
    };
    return (
        <VideoLightboxContainer
            key="content"
            initial="collapsed"
            animate="open"
            exit="collapsed"
            variants={{
                open: { opacity: 1 },
                collapsed: { opacity: 0 },
            }}
            transition={{
                duration: 0.25,
            }}
        >
            <Wrapper className="video-wrapper">
                <button
                    onClick={() => setIsVideoShowing(false)}
                    className="close-button"
                ></button>
                <div className="iframe-container">
                    <YouTube videoId="2g811Eo7K8U" opts={opts} />
                </div>
            </Wrapper>
        </VideoLightboxContainer>
    );
};

export default CollectionVideo;
